import { apiService } from "./api.service";
import { IContentTemplate } from "@/models/interfaces/content/content-template.model.interface";
import { IResponseModel } from "@/models/interfaces/response.model.interface";
import { ContentTemplateModel } from "@/models/content/content-template.model";

class ContentTemplateService {

    private static serviceInstance: ContentTemplateService;

    private constructor() { }

    public static get instance() {
        return this.serviceInstance || (this.serviceInstance = new this());
    }

    public async Create(template: IContentTemplate)
      : Promise<IResponseModel<IContentTemplate>> {
        return apiService.post(`/api/v1/contenttemplate`, template)
            .then((response) => {
                const result = response.data as IResponseModel<IContentTemplate>;
                return result;
            })
            .catch((error) => {
                const result: IResponseModel<IContentTemplate> = {
                    success: false,
                    result: new ContentTemplateModel()
                };
                return result;
            });
    }

    public async Get(id: number)
      : Promise<IResponseModel<IContentTemplate>> {
        return apiService.get(`/api/v1/contenttemplate/${id}`)
            .then((response) => {
                const result = response.data as IResponseModel<IContentTemplate>;
                return result;
            })
            .catch((error) => {
                const result: IResponseModel<IContentTemplate> = {
                    success: false,
                    result: new ContentTemplateModel()
                };
                return result;
            });
    }

    public async Update(template: IContentTemplate)
      : Promise<boolean> {
        return apiService.patch(`/api/v1/contenttemplate/${template.templateId}`, template)
            .then((response) => {
                return true;
            })
            .catch((error) => {
                return false;
            });
    }
}

// export a singleton instance in the global namespace
export const contentTemplateService = ContentTemplateService.instance;
